<template>
  <transition name="fade">
    <div class="modal modal-default">
      <div class="modal__overlay" @click="$emit('close')"></div>
      <div class="small-modal">
        <div class="small-modal__close" @click="$emit('close')">X</div>
        <div class="small-modal__head"><span>Attention</span></div>

        <div class="small-modal__body">{{ data }}</div>

        <div class="small-modal__footer">
          <div
            class="small-modal__footer__actions d-flex justify-content-between"
          >
            <button class="alert-danger" @click="$emit('close')">
              <span>Annuler ma souscription</span>
            </button>
            <button class="blue-button" @click="$emit('ok')">
              <span>Souscrire tout de même</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Preloader from "@/components/Preloader";

export default {
  name: "BrokerAssistanceErrorModal",
  components: {
    Preloader
  },
  props: {
    data: String
  },
  data() {},
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/BrokerAssistance/BrokerAssistanceErrorModal.vue